<template>
    <section
        class="InstagramFeed hide-until-mounted"
    >
        <div class="container">
            <div class="InstagramFeed__handle">
                <base-icon
                    icon="instagram"
                    class="text--lightblue"
                ></base-icon>
                <h2 class="h3">@VISITGIPPSLAND</h2>
            </div>
            <ul v-if="hashtags.length"
                class="InstagramFeed__hashtags flex-center-b mb-large hide--portable text--blue">
                <li
                    v-for="hashtag in hashtags"
                    :key="hashtag.hashtag"
                    class="InstagramFeed__hashtag"
                >
                    #{{ hashtag.hashtag }}
                </li>
            </ul>
            <div id="curator-feed-default-layout"></div>
        </div>
    </section>
</template>
<script>

import jsonp from 'browser-jsonp'
import axios from 'axios'

export default {
    name: 'InstagramFeed',
    props: {
        hashtags: {
            type: Array,
            default: null
        },
    },
    mounted () {
        var i, e, d = document, s = "script";i = d.createElement("script");i.async = 1;
        i.src = "https://cdn.curator.io/published/5cdbea4f-22b0-4b38-aabb-c2adce6941ce.js";
        e = d.getElementsByTagName(s)[0];e.parentNode.insertBefore(i, e);
    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .InstagramFeed__handle {
        position: relative;
        margin-bottom: getSpacing('xlarge');
        margin-top: getSpacing('xlarge');
        text-align: center;

        @include media-query(lap-and-up) {
            margin-bottom: getSpacing('large');
        }

        h2 {
            position: relative;
        }

        .BaseIcon {
            position: absolute;
            height: 100px!important;
            width: 100px!important;
            left: calc(50% - 50px);
            top: -35px!important;
            opacity: 0.5;
        }

        @include media-query(lap-and-up) {
            margin-bottom: getSpacing('large');
            margin-top: getSpacing('xlarge');

            .BaseIcon {
                top: -25px;
            }
        }
    }

    .InstagramFeed__hashtags {
        max-width: 600px;
        margin: auto;
    }
    .InstagramFeed__hashtag {
        font-weight: 700;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

</style>

